import { Search } from "lucide-react";

/**
 * Reusable "Search articles" input. Purely controlled — filtering happens
 * in the parent over data it already has, no API calls from this component.
 */
export default function ArticleSearchBar({ value, onChange, testId, placeholder = "Search by title, summary or topic…" }) {
  return (
    <div className="mb-6">
      <label htmlFor={`${testId}-input`} className="block text-sm font-medium text-ink mb-2">
        Search articles
      </label>
      <div className="relative max-w-md">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-soft pointer-events-none" />
        <input
          id={`${testId}-input`}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-2.5 rounded-full border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-teal/40"
          data-testid={`${testId}-input`}
        />
      </div>
    </div>
  );
}
